import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/FacturiFurnizorModels.cs ----------

export type SupplierInvoiceStatus = 'Draft' | 'MatchingException' | 'Approved' | 'Rejected'
export type InvoiceLineMatchStatus = 'Match' | 'PriceException' | 'QuantityException' | 'NoReference'
export type SupplierInvoiceKind = 'Factura' | 'NotaCredit'

export interface SupplierInvoiceLine {
  id: string | null
  lineNumber: number
  supplierArticleCode: string | null
  articleId: string | null
  articleCode: string | null
  description: string
  unitOfMeasureId: string | null
  unitOfMeasureCode: string | null
  quantity: number
  unitPrice: number
  vatRateId: string | null
  vatRatePercent: number | null
  netAmount: number
  vatAmount: number
  total: number
  matchStatus: InvoiceLineMatchStatus
}

export type SaveSupplierInvoiceLinePayload = {
  supplierArticleCode: string | null
  articleId: string | null
  description: string
  unitOfMeasureId: string | null
  quantity: number
  unitPrice: number
  vatRateId: string | null
}

export interface SupplierInvoiceListItem {
  id: string
  number: string
  kind: SupplierInvoiceKind
  issueDate: string
  dueDate: string
  supplierId: string
  supplierName: string
  status: SupplierInvoiceStatus
  total: number
  currency: string
  hasMatchingException: boolean
}

export interface SupplierInvoiceDetail {
  id: string
  number: string
  kind: SupplierInvoiceKind
  issueDate: string
  receivedDate: string
  dueDate: string
  supplierId: string
  supplierName: string
  purchaseOrderId: string | null
  purchaseOrderNumber: string | null
  goodsReceiptId: string | null
  goodsReceiptNumber: string | null
  supplierReturnId: string | null
  supplierReturnNumber: string | null
  isServiceInvoiceWithoutPO: boolean
  serviceInvoiceApprovalReason: string | null
  currency: string
  status: SupplierInvoiceStatus
  lines: SupplierInvoiceLine[]
  total: number
  attachmentFileName: string | null
}

export interface SaveSupplierInvoicePayload {
  number: string
  issueDate: string
  receivedDate: string
  dueDate: string
  supplierId: string
  purchaseOrderId: string | null
  goodsReceiptId: string | null
  isServiceInvoiceWithoutPO: boolean
  serviceInvoiceApprovalReason: string | null
  currency: string
  lines: SaveSupplierInvoiceLinePayload[]
}

export interface SupplierInvoiceListFilters { from?: string; to?: string; supplierId?: string }

export interface SupplierAgingBucket { label: string; minDays: number; maxDays: number | null; invoices: SupplierInvoiceListItem[]; total: number }
export interface SupplierAgingReport { buckets: SupplierAgingBucket[] }

export const listSupplierInvoices = (filters?: SupplierInvoiceListFilters) =>
  api.get<SupplierInvoiceListItem[]>('/achizitii/facturi', { params: filters }).then((r) => r.data)
export const getSupplierInvoice = (id: string) => api.get<SupplierInvoiceDetail>(`/achizitii/facturi/${id}`).then((r) => r.data)
export const getSupplierInvoicesExportUrl = (filters?: SupplierInvoiceListFilters) =>
  api.get<Blob>('/achizitii/facturi/export', { params: filters, responseType: 'blob' }).then((r) => r.data)
export const getSupplierAgingReport = () => api.get<SupplierAgingReport>('/achizitii/facturi/restante').then((r) => r.data)
export const getSupplierAgingReportExportUrl = () =>
  api.get<Blob>('/achizitii/facturi/restante/export', { responseType: 'blob' }).then((r) => r.data)

export interface PurchaseJournalEntry { invoiceNumber: string; issueDate: string; supplierName: string; vatRatePercent: number; netAmount: number; vatAmount: number; totalAmount: number }
export interface PurchaseVatRateSummary { vatRatePercent: number; netAmount: number; vatAmount: number; totalAmount: number }
export interface PurchaseJournal { from: string; to: string; entries: PurchaseJournalEntry[]; summary: PurchaseVatRateSummary[] }

export const getPurchaseJournal = (from: string, to: string) =>
  api.get<PurchaseJournal>('/achizitii/facturi/jurnal-achizitii', { params: { from, to } }).then((r) => r.data)
export const getPurchaseJournalExportUrl = (from: string, to: string) =>
  api.get<Blob>('/achizitii/facturi/jurnal-achizitii/export', { params: { from, to }, responseType: 'blob' }).then((r) => r.data)
export const createSupplierInvoice = (payload: SaveSupplierInvoicePayload) =>
  api.post<{ id: string }>('/achizitii/facturi', payload).then((r) => r.data)
export const updateSupplierInvoice = (id: string, payload: SaveSupplierInvoicePayload) => api.put(`/achizitii/facturi/${id}`, payload)
export const resolveMatchingException = (id: string, reason: string) => api.post(`/achizitii/facturi/${id}/rezolva-exceptie`, { reason })
export const rejectSupplierInvoice = (id: string) => api.post(`/achizitii/facturi/${id}/respinge`)

export const uploadSupplierInvoiceDocument = (id: string, file: File) => {
  const form = new FormData()
  form.append('file', file)
  return api.post(`/achizitii/facturi/${id}/document`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const getSupplierInvoiceDocument = (id: string) =>
  api.get<Blob>(`/achizitii/facturi/${id}/document`, { responseType: 'blob' }).then((r) => r.data)
